import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import { Injectable } from "@angular/core";
import { RequestBuilder } from "../classes/request-builder";
import { Observable } from "rxjs";
import * as Enum from '../utils/enums';

@Injectable()
export class RichiestaService extends BaseService {

    constructor(http: Http) {
        super(http)
    }

    /**
     * save new richiesta
     * @param reqBuilder 
     */
    save(reqBuilder: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost("richiesta/save", payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * retrieve all request type
     * @param reqBuilder 
     */
    getAllTipiRichiesta(reqBuilder: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost("tipoRichiesta/fetch", payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
    * Get richiesta
    * @param reqBuilder 
    */
    getRichiestaData(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('richiesta/fetchSingle', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * get suggerimenti
     * @param reqBuilder 
     */
    getSuggerimenti(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('richiesta/fetchsuggerimenti', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
    * Change status richiesta
    * @param reqBuilder 
    */
    changeStatusRichiesta(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('richiesta/changeStatus', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }


    /**
   * Get richiesta
   * @param reqBuilder 
   */
    getAllRichiesta(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('richiesta/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * delete richiesta
     * @param reqBuilder 
     */
    deleteRichiesta(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('richiesta/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }
}